import UserStampHistoryContainer from './UserStampHistoryContainer';
export default UserStampHistoryContainer;
